import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import Tooltip from 'primevue/tooltip';

import App from './App.vue';
import router from './router';
import i18n, { primeVueLocaleEn, setPrimeVueConfig } from './i18n';

import 'primevue/resources/themes/lara-light-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import './assets/styles/main.scss';

const app = createApp(App);

app.use(createPinia());
app.use(i18n);
app.use(router);
app.use(PrimeVue, { ripple: true, locale: primeVueLocaleEn });
app.use(ToastService);
app.use(ConfirmationService);
app.directive('tooltip', Tooltip);

// Store PrimeVue config reference for locale switching
setPrimeVueConfig(app.config.globalProperties.$primevue.config);

app.mount('#app');
